import { all, put, takeEvery } from 'redux-saga/effects';

import { openModal } from '../actions/Modal';
import { ShareActions } from '../constants/Share';

function* showShareCoachmark({ body }) {
  yield put(
    openModal({
      modalType: 'ModalCoachMark',
      body,
    }),
  );
}

export default function* shareSaga() {
  yield all([takeEvery(ShareActions.SHOW_SHARE_COACHMARK, showShareCoachmark)]);
}
